import * as React from 'react';
import classNames from 'classnames';
import Spinner from '~/components/Spinner';
import './style.scss';

const spinnerSize = {
  small: 18,
  medium: 20,
  large: 24,
};

const spinnerColor = {
  primary: '#ffffff',
  secondary: '#429eff',
  tertiary: '#1d1d1d',
  'destructive-primary': '#ffffff',
  'destructive-secondary': '#ff7676',
  'destructive-tertiary': '#ff7676',
};

export type ButtonAppearance = 'primary' | 'secondary' | 'tertiary' | 'destructive-primary' | 'destructive-secondary' | 'destructive-tertiary';
export interface IButtonProps extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  disabled?: boolean;
  loading?: boolean;
  title?: string;
  stretched?: boolean;
  children?: React.ReactNode;
  size?: 'small' | 'medium' | 'large';
  appearance?: ButtonAppearance;
}

const Button = ({
  title = 'Action',
  style,
  disabled = false,
  loading = false,
  stretched = false,
  children = null,
  size = 'medium',
  appearance = 'primary',
  onClick,
  className = '',
  ...props
}: IButtonProps): React.ReactElement => {
  return (
    <button
      {...props}
      onClick={onClick}
      disabled={disabled}
      className={classNames('button', className, {
        'button-width-stretched': stretched,
        'button-sz-small': size === 'small',
        'button-sz-medium': size === 'medium',
        'button-sz-large': size === 'large',
        'button-lvl-primary': appearance === 'primary',
        'button-lvl-secondary': appearance === 'secondary',
        'button-lvl-tertiary': appearance === 'tertiary',
        'button-lvl-destructive-primary': appearance === 'destructive-primary',
        'button-lvl-destructive-secondary': appearance === 'destructive-secondary',
        'button-lvl-destructive-tertiary': appearance === 'destructive-tertiary',
        'button-state-loading': loading,
      })}
      style={style}>
      {children || title}
      {loading && <Spinner size={spinnerSize[size]} color={spinnerColor[appearance]} className="button-spinner" />}
    </button>
  );
};

export default Button;
